import { T_Major } from "./ModulePropTypes";
import { PT_Org } from "./ModulePermitTypes";

export const _templates = {
  id: "templates",
  permitType: PT_Org,
  type: T_Major,
  modules: [],
};
